<template>
  <div class="recording-container">
    <div class="recording-bar bar-1"></div>
    <div class="recording-bar bar-2"></div>
    <div class="recording-bar bar-3"></div>
    <div class="recording-bar bar-4"></div>
    <div class="recording-bar bar-5"></div>
    <div class="recording-bar bar-6"></div>
    <div class="recording-bar bar-7"></div>
    <div class="recording-bar bar-8"></div>
    <div class="recording-bar bar-9"></div>
    <div class="recording-bar bar-10"></div>
    <div class="recording-bar bar-11"></div>
    <div class="recording-bar bar-12"></div>
    <div class="recording-bar bar-13"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {},
  components: {},
};
</script>

<style scoped lang="scss">
.recording-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 38px;
}

.recording-bar {
  width: 3px;
  margin: 0 3px;
  border-radius: 2px;
  background-color: #00c89d;
  animation-duration: 1s;
  animation-iteration-count: infinite;
  animation-timing-function: ease-in-out;
}

.bar-1 {
  animation-name: bar-animation-1;
}

.bar-2 {
  animation-name: bar-animation-2;
  animation-delay: 0.2s;
}

.bar-3 {
  animation-name: bar-animation-3;
  animation-delay: 0.4s;
}

.bar-4 {
  animation-name: bar-animation-4;
  animation-delay: 0.6s;
}

.bar-5 {
  animation-name: bar-animation-5;
  animation-delay: 0.8s;
}
.bar-6 {
  animation-name: bar-animation-6;
}

.bar-7 {
  animation-name: bar-animation-2;
  animation-delay: 0.2s;
}

.bar-8 {
  animation-name: bar-animation-7;
  animation-delay: 0.4s;
}

.bar-9 {
  animation-name: bar-animation-8;
  animation-delay: 0.6s;
}

.bar-10 {
  animation-name: bar-animation-5;
  animation-delay: 0.8s;
}
.bar-11 {
  animation-name: bar-animation-3;
  animation-delay: 0.8s;
}
.bar-12 {
  animation-name: bar-animation-2;
  animation-delay: 0.8s;
}
.bar-13 {
  animation-name: bar-animation-1;
  animation-delay: 0.8s;
}

@keyframes bar-animation-1 {
  0%,
  100% {
    height: 10px;
  }
  50% {
    height: 15px;
  }
}

@keyframes bar-animation-2 {
  0%,
  100% {
    height: 12px;
  }
  50% {
    height: 28px;
  }
}

@keyframes bar-animation-3 {
  0%,
  100% {
    height: 20px;
  }
  50% {
    height: 10px;
  }
}

@keyframes bar-animation-4 {
  0%,
  100% {
    height: 38px;
  }
  50% {
    height: 19px;
  }
}

@keyframes bar-animation-5 {
  0%,
  100% {
    height: 20px;
  }
  50% {
    height: 36px;
  }
}
@keyframes bar-animation-6 {
  0%,
  100% {
    height: 18px;
  }
  50% {
    height: 29px;
  }
}
@keyframes bar-animation-7 {
  0%,
  100% {
    height: 27px;
  }
  50% {
    height: 38px;
  }
}
@keyframes bar-animation-8 {
  0%,
  100% {
    height: 38px;
  }
  50% {
    height: 13px;
  }
}
</style>
